import { api } from "infra/axios";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { Evento } from "../types";

function useEventoDetalhado() {
  const params = useParams<{ calendarioId: string }>();
  const url = `v2/ingressos/calendario/${params.calendarioId}/eventos`;


  return useQuery(
    ["eventos", params.calendarioId],
    async () => {
      const { data } = await api.get<Evento[]>(url);
      return data;
    },

  );
}

export default useEventoDetalhado;
